import { Component, Input, OnInit } from '@angular/core';
import { BalanceService } from 'src/app/services/balance.service';
import { ParamServicesService } from 'src/app/services/param-services.service';

@Component({
  selector: 'app-container-card-subscription',
  templateUrl: './container-card-subscription.component.html',
  styleUrls: ['./container-card-subscription.component.scss'],
})
export class ContainerCardSubscriptionComponent implements OnInit {
  @Input() products: any[] = [];
  @Input() loop: any = undefined;

  constructor(
    public paramSv: ParamServicesService,
    public balanceSv: BalanceService
  ) {}

  ngOnInit() {
    console.log('this.products :>> ', this.products);
  }
}
